import { OrderButton as OrderButtonBase } from "@omni/components/components/Product/ECommerce/components/orderButton/orderButton";

import { OrderButtonComponent } from "@/components/Product/ECommerce/components/orderButton/orderButton.component";

export const OrderButton = () => {
    return (
        <OrderButtonBase>
            <OrderButtonComponent />
        </OrderButtonBase>
    );
};
